import {
  GET_ALL_PAYMENTS_REQUEST,
  GET_ALL_PAYMENTS_SUCCESS,
  GET_ALL_PAYMENTS_FAIL,
  GET_PAYMENT_BY_ID_REQUEST,
  GET_PAYMENT_BY_ID_SUCCESS,
  GET_PAYMENT_BY_ID_FAIL,
  GET_PAYMENT_DETAILS_BY_ID_REQUEST,
  GET_PAYMENT_DETAILS_BY_ID_SUCCESS,
  GET_PAYMENT_DETAILS_BY_ID_FAIL,
  ADD_PAYMENT_REQUEST,
  ADD_PAYMENT_SUCCESS,
  ADD_PAYMENT_FAIL,
  UPDATE_PAYMENT_REQUEST,
  UPDATE_PAYMENT_SUCCESS,
  UPDATE_PAYMENT_FAIL,
} from "../constants/PaymentConstants"

import PaymentService from "../Services/PaymentService"

// ✅ Get All Payments
export const GetAllPaymentsAction = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_PAYMENTS_REQUEST })
    const { data } = await PaymentService.GetAllPayments()
    dispatch({
      type: GET_ALL_PAYMENTS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: GET_ALL_PAYMENTS_FAIL,
      payload: error.response?.data?.message || error.message,
    })
  }
}

// ✅ Get Payment by ID
export const GetPaymentByIdAction = (paymentId) => async (dispatch) => {
  try {
    dispatch({ type: GET_PAYMENT_BY_ID_REQUEST })
    const { data } = await PaymentService.GetPaymentById(paymentId)
    dispatch({
      type: GET_PAYMENT_BY_ID_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: GET_PAYMENT_BY_ID_FAIL,
      payload: error.response?.data?.message || error.message,
    })
  }
}

// ✅ Get Payment Details by ID
export const GetPaymentDetailsByIdAction = (paymentId) => async (dispatch) => {
  try {
    dispatch({ type: GET_PAYMENT_DETAILS_BY_ID_REQUEST })
    const { data } = await PaymentService.GetPaymentDetailsById(paymentId)
    dispatch({
      type: GET_PAYMENT_DETAILS_BY_ID_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: GET_PAYMENT_DETAILS_BY_ID_FAIL,
      payload: error.response?.data?.message || error.message,
    })
  }
}

// ✅ Add Payment (CREATE - no payment_id)
export const AddPaymentAction = (paymentData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_PAYMENT_REQUEST })
    console.log("📤 Add Payment Data to Send:", paymentData)

    // Ensure payment_id is NOT provided for CREATE
    const dataToSend = { ...paymentData }
    if (dataToSend.payment_id) {
      delete dataToSend.payment_id
    }

    const response = await PaymentService.SavePayment(dataToSend)
    console.log("📥 Add Payment API Response:", response.data)

    if (response.data?.StatusCode === 208 || response.data?.StatusCode === 200) {
      dispatch({
        type: ADD_PAYMENT_SUCCESS,
        payload: response.data,
      })
    } else {
      dispatch({
        type: ADD_PAYMENT_FAIL,
        payload: response.data?.Result || response.data?.message || "Add payment failed",
      })
    }
  } catch (error) {
    console.error("❌ AddPaymentAction Error:", error)
    dispatch({
      type: ADD_PAYMENT_FAIL,
      payload: error.response?.data?.message || error.message || "Network error occurred",
    })
  }
}

// ✅ Update Payment (UPDATE - with payment_id)
export const UpdatePaymentAction = (paymentData) => async (dispatch) => {
  try {
    // Check if trying to update a paid payment
    if (paymentData.status === 'Paid' || paymentData.paid_amount === paymentData.total_amount) {
      throw new Error("Cannot update a payment that is already fully paid.");
    }
    
    dispatch({ type: UPDATE_PAYMENT_REQUEST })
    console.log("📤 Update Payment Data:", paymentData)

    // Ensure payment_id IS provided for UPDATE
    if (!paymentData.payment_id) {
      throw new Error("Payment ID is required for update")
    }

    const response = await PaymentService.SavePayment(paymentData)
    console.log("📥 Update Payment API Response:", response.data)

    if (response.data?.StatusCode === 208 || response.data?.StatusCode === 200) {
      dispatch({
        type: UPDATE_PAYMENT_SUCCESS,
        payload: response.data,
      })
    } else {
      dispatch({
        type: UPDATE_PAYMENT_FAIL,
        payload: response.data?.Result || response.data?.message || "Update payment failed",
      })
    }
  } catch (error) {
    console.error("❌ UpdatePaymentAction Error:", error)
    dispatch({
      type: UPDATE_PAYMENT_FAIL,
      payload: error.response?.data?.message || error.message || "Network error occurred",
    })
  }
}